import { CompanyPageLayoutNew } from './CompanyPageLayoutNew'
import type { CompanySidebarHeader, SidebarTabConfig } from './Sidebar'
import type { BreadcrumbItem } from 'components/Layout/Header/types'

// Export CompanyContentSections for use in company pages
export { CompanyContentSections } from './CompanyContentSections'

interface CompanyPageLayoutProps {
  breadcrumbRoot?: string
  breadcrumbs?: { breadcrumb: string; title?: string; url?: string }[]
  chainProxyId: number
  sidebar: {
    header: CompanySidebarHeader
    tabs: SidebarTabConfig[]
  }
  doorId?: number
  address?: string
  phone?: string
  children?: React.ReactNode
  /** Entity breadcrumbs for new navigation header (e.g., Chain: McDonald's | Door: Store #123) */
  entityBreadcrumbs?: BreadcrumbItem[]
  /** Dynamic category info for unmatched/user-generated pages */
  categoryInfo?: {
    categorySlug: string
    subCategorySlug: string
  }
}

export function CompanyPageLayout(props: CompanyPageLayoutProps) {
  return <CompanyPageLayoutNew {...props} />
}
